/*
  elewa-quickadd.js
  -----------------
  What it does: the "add to bag" button on product cards (snippets/elewa-product-card.liquid). Adds one to the bag
  without leaving the page, then the button reads "added ✓" for two seconds and the header bag count updates.
  If it fails, the button says so for a moment. Loaded by each card; runs once.
*/
(function () {
  'use strict';
  if (window.elewaQuickAdd) return; window.elewaQuickAdd = true;
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-elewa-quickadd]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button'); if (btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.getAttribute('data-label') || 'add to bag';
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('no'); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-elewa-bag-count]').forEach(function (el) { el.textContent = cart.item_count; });
        btn.classList.add('is-added'); btn.firstChild.textContent = 'added ✓';
      })
      .catch(function () { btn.firstChild.textContent = 'try again'; })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.classList.remove('is-added'); btn.firstChild.textContent = label; }, 2000);
      });
  });
})();
